import { render } from "./ConfigurationTable.vue?vue&type=template&id=c38353ca&scoped=true"
import script from "./ConfigurationTable.vue?vue&type=script&lang=js"
export * from "./ConfigurationTable.vue?vue&type=script&lang=js"

import "./ConfigurationTable.vue?vue&type=style&index=0&id=c38353ca&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c38353ca"]])

export default __exports__